import { background } from "@/theme/colors";
import { spacing } from "@/theme/variables";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

export type TIndustryNameLabelProps = {
  /** Industry name displayed in this row */
  name: string;
  /** Every industry name of the list - rendered as hidden sizers so all rows share the width of the longest name */
  allNames: string[];
};

const MIN_WIDTH = 144;
/** Cap the label so a very long industry name cannot eat the row content */
const MAX_WIDTH = "50%";

export const IndustryNameLabel: FC<TIndustryNameLabelProps> = ({ name, allNames }) => {
  return (
    <Stack
      sx={{
        bgcolor: background.secondary,
        minWidth: MIN_WIDTH,
        maxWidth: MAX_WIDTH,
        flexShrink: 0,
        p: spacing.sm,
        textAlign: "start",
        alignSelf: "stretch",
        justifyContent: "center",
        whiteSpace: "nowrap",
      }}
    >
      <Typography variant="body14Bold" letterSpacing={0} title={name} sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
        {name}
      </Typography>
      {/* Invisible sizers: keep the label width equal across rows (widest industry name wins, up to MAX_WIDTH) */}
      <Stack aria-hidden sx={{ height: 0, overflow: "hidden", visibility: "hidden" }}>
        {allNames.map((industryName, index) => (
          <Typography key={index} variant="body14Bold" letterSpacing={0}>
            {industryName}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};
